<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
    defineProps<{
        size?: "sm" | "md" | "lg" | number;
        color?: string;
    }>(),
    {
        size: "md",
        color: "currentColor",
    },
);

const sizeClass = computed(() => {
    if (typeof props.size === "number") return "";
    return `ui-loading-icon--${props.size}`;
});

const colorStyle = computed(() => {
    const style: Record<string, string> = { color: props.color };
    if (typeof props.size === "number") {
        style.fontSize = `${props.size}px`;
    }
    return style;
});
</script>

<template>
    <i class="iconfont icon-loading ui-loading-icon" :class="sizeClass" :style="colorStyle" />
</template>
